class SignupFulfilmentController {
    constructor(settings) {
        this.settings = settings;
    }

    $onInit() {
        this.signup.TypeOfDeliveryMethod = 'Delivered';
        this.canFocusForm = false;
    }

    fulfilmentOptionChanged() {
        this.clearStoreSelection();
        this.canFocusForm = true;
    }

    manualDeliveryAddressSelected(address) {
        this.signup.TypeOfAddress = 'manual';
        this.signup.AddressStreet1 = address.street1;
        this.signup.AddressStreet2 = address.street2;
        this.signup.AddressSuburbId = address.suburbId;
        this.signup.AddressPostcode = address.postcode;
    }

    autoDeliveryAddressSelected(address) {
        this.signup.TypeOfAddress = 'auto';
        this.signup.AmasAddressId = address.Id;
    }

    pickupAddressSelected(storeAddress) {
        this.signup.TypeOfAddress = 'auto';
        this.selectedStoreName = storeAddress.AddressText;
        this.signup.AmasPickupStoreAddressId = storeAddress.AddressId;
    }

    autoBillingAddressSelected(billingAddress) {
        this.signup.TypeOfAddress = 'auto';
        this.signup.AmasAddressId = billingAddress.Id;
    }

    manualBillingAddressSelected(billingAddress) {
        // The signup request reuses the delivery paramters
        // for billing when pickup is selected.
        this.manualDeliveryAddressSelected(billingAddress);
    }

    clearStoreSelection() {
        this.selectedStoreName = null;
        this.signup.AmasPickupStoreAddressId = null;
    }
}

SignupFulfilmentController.$inject = ['Settings'];

const signupFulfilmentComponentDefinition = {
    controller: SignupFulfilmentController,
    bindings: {
        signup: '<',
        initialAddress: '<',
    },
    template: require('./signup-fulfilment.component.html').trim(),
};

module.exports = {
    SignupFulfilmentController,
    signupFulfilmentComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/signup/signup-fulfilment.component.js